import { each } from 'lodash';
import { Controller } from '@hotwired/stimulus';
// import { EVENTO_CONTROLLER_CARGADO } from '@/controllers/application_controller';

/* global $, Cifra */
export default class extends Controller {
  connect() {
    this.$element = $(this.element);

    $('.btn-desglosar-precios').on('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const $btn = $('.btn-desglosar-precios');
      const $icon = $btn.find('i');
      this.#desglosarPrecios($icon.hasClass('fa-angle-double-left'));
    });

    // Ocultamos al inicio así para que no haga fade
    $('.col-precio-desglosable').hide();
    this.#desglosarPrecios(false);

    this.#gestionCalcularTotales();
  }

  // eslint-disable-next-line class-methods-use-this
  #desglosarPrecios(mostrar) {
    const $btn = $('.btn-desglosar-precios');
    const $icon = $btn.find('i');
    let title = '';
    if (mostrar) {
      $('.col-precio-desglosable').fadeIn(Cifra.Conf.ANIMATION_SPEED);
    } else {
      $('.col-precio-desglosable').fadeOut(Cifra.Conf.ANIMATION_SPEED);
    }
    $icon.toggleClass('fa-angle-double-left', !mostrar);
    $icon.toggleClass('fa-angle-double-right', mostrar);
    if (mostrar) {
      title = 'Ocultar desglose de importes';
    } else {
      title = 'Mostrar desglose de importes';
    }
    $btn.attr('data-original-title', title);
  }

  // eslint-disable-next-line class-methods-use-this
  #gestionCalcularTotales() {
    $('#btn-calcular-totales').on('ajax:success', function onSuccess(event, data) {
      const $filas = $('.resultados-cobros .listado-resultados-totales');
      each(['recibido_fp', 'recibido', 'pendiente', 'total'], (tipo) => {
        const $fila = $filas.filter(`.importe-${tipo}`);
        $fila.removeClass('hide');
        const importe = Cifra.Utils.precio(data.importes[tipo]);
        $fila.find('.importe').text(importe);
        $fila.find('.num-cobros').text(`(${data.numero_cobros} cobros)`);
      });
      $(this).addClass('hide');
    });
  }
}
